import {
  freetext_default
} from "../../chunk-HY5MKJKJ.js";
import "../../chunk-OZAUPKH3.js";
import "../../chunk-JTIAEL3E.js";
export {
  freetext_default as default
};
